import { Pipe, PipeTransform } from '@angular/core';
import { Departement } from '../../models/departement';

@Pipe({
	name: 'filterDepartementByName'
})
export class FilterDepartementByNamePipe implements PipeTransform {
	transform(departement: Departement[], filter: string): Departement[] {
		if (
			!departement ||
			!filter ||
			departement === null ||
			filter === null ||
			filter === ''
		) {
			return departement;
		}

		return departement.filter((departement: Departement) => {
			if (departement.name) {
				// TODO: add lastName too
				return departement.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
